import React, { Dispatch, SetStateAction } from 'react';
import { ProviderLocation } from './ProviderLocation';

export interface ProviderLocationsProps {
    showLocations: boolean;
    locations: undefined | LocationType[];
    selectedLocation: undefined | LocationType;
    setSelectedLocation: Dispatch<SetStateAction<LocationType>>;
}
export function ProviderLocations({
    showLocations,
    locations,
    selectedLocation,
    setSelectedLocation,
}: ProviderLocationsProps) {
    const [showAllLocations, setShowAllLocations] = React.useState(false);
    const sortedLocations = React.useMemo(() => {
        if (!locations) return [];
        const result = locations.sort((a, b) => {
            if (b.is_default) return 1;
            if (a.is_default) return -1;
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
        if (!showAllLocations) return result.slice(0, 5);
        return result;
    }, [locations, showAllLocations]);

    if (!showLocations || sortedLocations.length === 0) {
        return null;
    }

    return (
        <div>
            {sortedLocations.map((location) => (
                <ProviderLocation
                    key={location.id}
                    location={location}
                    selectedLocation={selectedLocation}
                    setSelectedLocation={setSelectedLocation}
                />
            ))}
            {!showAllLocations && locations && locations.length > 5 && (
                <button
                    className="link-button"
                    type="button"
                    onClick={() => setShowAllLocations(true)}
                >
                    More...
                </button>
            )}
        </div>
    );
}
